import React, { useState, useEffect } from "react";
import POSNavOrderItem from "./POSNavOrderItem";
import { languageHelper } from "../../config/helperFunctions";

function SideNavPOS({
  orders,
  selectOrder,
  handleSelectOrder,
  handleEditOrder,
  handleOrderDetailModal,
  handleOrderDetails,
  handleStatusUpdate,
  fetchOrders,
  // handleCreateInvoice,
  setShowFinalizeOrderModal,
  setPayAmount,
  setTotalPayableFinal,
  setOpenKotModal,
}) {
  const [allOrders, setAllOrders] = useState(orders);
  const [filteredOrders, setFilteredOrders] = useState(orders);
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";

  useEffect(() => {
    setAllOrders(orders);
    setFilteredOrders(orders);
  }, [orders]);

  const handleSearch = (e) => {
    console.log(e.target.value.toLowerCase());
    const searchValue = e.target.value.toLowerCase();

    const filteredOrder = allOrders.filter(
      (order) =>
        String(order.sale_no).toLowerCase().includes(searchValue) ||
        order.customer?.name.toLowerCase().includes(searchValue) ||
        order.guest?.name.toLowerCase().includes(searchValue) ||
        order.guest?.phone.toLowerCase().includes(searchValue) ||
        order.customer?.phone.toLowerCase().includes(searchValue)
    );
    setFilteredOrders(filteredOrder);
  };

  return (
    <aside className="">
      <div className="bg-d-bg max-w-[200px] w-full fixed top-0 left-0 bottom-0 rounded-tr-2xl rounded-br-2xl text-white py-2 px-2 pos-side-scrollbar">
        <div className="flex flex-col gap-y-2 h-screen">
          <div>
            <p className="font-semibold moving-text">Imdady RMS</p>
          </div>
          <div className="flex gap-x-2 items-center self-end">
            <span className="bg-d-bg-dark rounded-lg p-2">{languageHelper(defaultLang, "Running Orders")}</span>
            <button onClick={() => fetchOrders()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-refresh-ccw"
              >
                <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                <path d="M3 3v5h5" />
                <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                <path d="M16 16h5v5" />
              </svg>
            </button>
          </div>
          <div>
            <input
              className="bg-d-bg-dark border border-white text-white text-xs p-1 rounded-md w-full focus:outline-none"
              placeholder={languageHelper(defaultLang, "Table, Order Number, Customer")}
              type="text"
              onChange={handleSearch}
            />
          </div>
          <div className="flex-1 overflow-y-scroll relative">
            <div className="relative top-0 left-0 bottom-0 overflow-y-auto pos-side-scrollbar">
              {filteredOrders.map((item, index) => (
                <POSNavOrderItem
                  key={index}
                  order={item}
                  selectOrderId={selectOrder?.id}
                  handleSelectOrder={handleSelectOrder}
                  handleOrderDetailModal={handleOrderDetailModal}
                  handleOrderDetails={handleOrderDetails}
                />
              ))}
            </div>
          </div>
          <div className="pb-4">
            <button
              onClick={() => handleEditOrder()}
              className="bg-d=bg-dark w-full flex gap-x-1 justify-center items-center py-1 rounded-md text-xs my-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-file-edit"
              >
                <path d="M4 13.5V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-5.5" />
                <polyline points="14 2 14 8 20 8" />
                <path d="M10.42 12.61a2.1 2.1 0 1 1 2.97 2.97L7.95 21 4 22l.99-3.95 5.43-5.44Z" />
              </svg>
              <span>{languageHelper(defaultLang, "Edit Order")}</span>
            </button>
            <button
              onClick={() => {
                setPayAmount(selectOrder.total_payable);
                setTotalPayableFinal(selectOrder.total_payable);
                setShowFinalizeOrderModal(true);
              }}
              className="bg-d-bg-dark w-full flex gap-x-1 justify-center items-center py-1 rounded-md text-xs my-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-file-text"
              >
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" x2="8" y1="13" y2="13" />
                <line x1="16" x2="8" y1="17" y2="17" />
                <line x1="10" x2="8" y1="9" y2="9" />
              </svg>
              <span>{languageHelper(defaultLang, "Create Invoice & Close")}</span>
            </button>
            <div className="flex gap-x-2">
              <button
                onClick={() => {
                  handleOrderDetails(selectOrder);
                  setTimeout(() => {
                    handleOrderDetailModal(true);
                  }, 100);
                }}
                className="bg-d-bg-dark w-full flex gap-x-1 justify-center items-center py-1 rounded-md text-xs my-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-info"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 16v-4" />
                  <path d="M12 8h.01" />
                </svg>
              </button>
              <button
                className="bg-d-bg-dark w-full flex gap-x-1 justify-center items-center py-1 rounded-md text-xs my-1"
                onClick={() => {
                  handleOrderDetails(selectOrder);
                  setTimeout(() => {
                    setOpenKotModal(true);
                  }, 100);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-printer"
                >
                  <polyline points="6 9 6 2 18 2 18 9" />
                  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                  <rect width="12" height="8" x="6" y="14" />
                </svg>
              </button>
            </div>
            <div className="flex gap-x-2">
              <button
                onClick={() => {
                  if (
                    window.alert("Are you sure you want to close this order?")
                  )
                    return;
                  handleStatusUpdate("closed", selectOrder.id);
                }}
                className="bg-d-bg-dark w-full flex gap-x-1 justify-center items-center py-1 rounded-md text-xs my-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-ban"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m4.9 4.9 14.2 14.2" />
                </svg>
              </button>
              <button
                className="bg-d-bg-dark w-full flex gap-x-1 justify-center items-center py-1 rounded-md text-xs my-1 cursor-not-allowed"
                disabled
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  width="16"
                  fill="white"
                  viewBox="0 0 512 512"
                >
                  <path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default SideNavPOS;
